import LaneManagement from '../../components/lane-management';

const LaneManagementPage = () => {
  return <LaneManagement />;
};

export default LaneManagementPage;
